export default __webpack_public_path__ + "static/media/logo1.c963c9fa.png";